/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StageHeader/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Sort from './Sort/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaIconAdd from 'DesignSystem/Svgs/TysiaIconAdd/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2NotifyAdd from 'DesignSystem/Svgs/Tysiav2NotifyAdd/index'
import Tysiav2NotifyYes from 'DesignSystem/Svgs/Tysiav2NotifyYes/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function StageHeader({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/StageHeader",
  title,
  count,
  stageId,
  isCurrentUserSubscribed
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let onClick = fromHelpers.useOnAddClick({
  children,
  viewPath,
  title,
  count,
  stageId,
  isCurrentUserSubscribed
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let onClick1 = fromHelpers.useOnToggleSubscribeClick({
  children,
  viewPath,
  title,
  count,
  stageId,
  isCurrentUserSubscribed
  
})
let dtColorsGreen800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.800'
        })
  return (<React.Fragment
>
<div
  data-testid="StageHeader.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-1AoT1S': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mb-2-1AoT1S': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 fontSize={13}
 lineHeight="20px"
 weight="medium"
 text={title}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 fontSize={13}
 lineHeight="20px"
 weight="medium"
 text={count}
/>
<div
  data-testid="StageHeader.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Sort
  viewPath={`${viewPath}/Sort`}
 count={count}
/>
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 data={stageId}
 onClick={onClick}
>
{childProps => (
<TysiaIconAdd
{...childProps}
  viewPath={`${viewPath}/TysiaIconAdd`}
 fill={dtColorsNeutral400}
 width={24}
 height={24}
/>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 data={stageId}
 data={isCurrentUserSubscribed}
 onClick={onClick1}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={!isCurrentUserSubscribed}>
<Tysiav2NotifyAdd
{...childProps}
  viewPath={`${viewPath}/Tysiav2NotifyAdd`}
 width={14}
 height={14}
 fill={dtColorsNeutral400}
/>
</fromFlow.When>
<fromFlow.When is={isCurrentUserSubscribed}>
<Tysiav2NotifyYes
{...childProps}
  viewPath={`${viewPath}/Tysiav2NotifyYes`}
 width={14}
 height={14}
 fill={dtColorsGreen800}
/>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}